import React, { useEffect, useState } from "react";
import { Button, Header, Heading, MainContainer } from "../../globalStyles";
import {
  FormContainer,
  Input,
  InputContainer,
  InputLabel,
  ResetPassContainer,
  Wrapper,
} from "./resetPassStyles";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetPassData } from "../../redux/apiCalls";
import { ToastContainer } from "react-toastify";
const ResetPass = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isFetching, error, resetData } = useSelector((state) => state.reset);
  const handleSubmit = async (e) => {
    e.preventDefault();
    resetPassData(dispatch, { email });
  };
  useEffect(() => {
    if (resetData) {
      setTimeout(() => {
        navigate("/confirmpass");
      }, 800);
    }
  }, [resetData]);

  return (
    <>
      <MainContainer
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          paddingTop: "80px",
        }}
      >
        <ResetPassContainer>
          <Header>
            <Heading>Reset Password</Heading>
          </Header>

          <Wrapper>
            <form onSubmit={handleSubmit}>
              <FormContainer>
                <InputContainer>
                  <InputLabel>E-Mail Address</InputLabel>
                  <Input
                    name="email"
                    required="true"
                    type="email"
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                </InputContainer>
                <Button type="submit" className="resetButton">
                  Send Password Reset Link
                </Button>
              </FormContainer>
            </form>
          </Wrapper>
        </ResetPassContainer>
        <ToastContainer position="bottom-right" newestOnTop />
      </MainContainer>
    </>
  );
};

export default ResetPass;
